import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { resetPasswordWithToken } from '../services/auth';
import { getErrorMessage } from '../lib/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div className="max-w-md mx-auto mt-8">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <p className="text-red-600">Ugyldigt nulstillingslink. Anmod om et nyt via login-siden.</p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== passwordRepeat) {
      setError('Adgangskoderne er ikke ens');
      return;
    }

    setIsLoading(true);
    try {
      await resetPasswordWithToken(token, password);
      setDone(true);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-8">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Vælg ny adgangskode</h2>

        {done ? (
          <div className="space-y-4">
            <div className="p-3 bg-green-50 border border-green-400 rounded-lg">
              <p className="text-sm text-green-700">
                Din adgangskode er blevet ændret. Du kan nu logge ind.
              </p>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary w-full"
            >
              Gå til login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="new-password" className="block text-sm font-medium text-gray-700 mb-1">
                Ny adgangskode
              </label>
              <input
                type="password"
                id="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                className="input"
                placeholder="Mindst 8 tegn"
              />
            </div>
            <div>
              <label htmlFor="new-password-repeat" className="block text-sm font-medium text-gray-700 mb-1">
                Gentag adgangskode
              </label>
              <input
                type="password"
                id="new-password-repeat"
                value={passwordRepeat}
                onChange={(e) => setPasswordRepeat(e.target.value)}
                required
                className="input"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="p-3 bg-red-50 border border-red-400 rounded-lg">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Gemmer...' : 'Gem ny adgangskode'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
